import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../../../atoms/Icon'

const useStyles = makeStyles(theme => ({
  collapsed: {
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(0.75, 1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 'var(--font-size-xs)',
    color: 'var(--color-neutral-400)',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
    borderRadius: '4px',
    backgroundColor: 'var(--surface-bg-color-d2)',
    border: '1px solid var(--color-neutral-600)',
    '&:hover': {
      backgroundColor: 'var(--surface-bg-color-d3)'
    }
  },
  chevron: {
    fontSize: '12px',
    opacity: 0.6
  },
  toolName: {
    fontWeight: 500,
    color: 'var(--text-color-main)'
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    padding: theme.spacing(0.25, 0.5),
    borderRadius: '4px',
    fontSize: '10px',
    fontWeight: 500
  },
  success: {
    backgroundColor: 'var(--color-success-100)',
    color: 'var(--color-success-700)'
  },
  error: {
    backgroundColor: 'var(--color-error-100)',
    color: 'var(--color-error-700)'
  }
}))

function ToolCallCollapsed ({ toolCall, toolResult, onClick }) {
  const classes = useStyles()

  let status = 'success'
  if (toolResult) {
    try {
      const parsed = typeof toolResult === 'string' ? JSON.parse(toolResult) : toolResult
      if (parsed.success !== undefined) {
        status = parsed.success ? 'success' : 'error'
      }
    } catch {
      // Default to success if parsing fails
    }
  } else {
    // No result yet, default to success
    status = 'success'
  }

  return (
    <div className={classes.collapsed} onClick={onClick}>
      <Icon name='chevronRight' className={classes.chevron} />
      <span className={classes.toolName}>{toolCall?.name || 'tool'}</span>
      <span className={`${classes.statusBadge} ${classes[status]}`}>
        {status === 'success' ? '✅' : '❌'}
        {status === 'success' ? 'Success' : 'Failed'}
      </span>
      <Icon name='chevronDown' className={classes.chevron} style={{ marginLeft: 'auto' }} />
    </div>
  )
}

ToolCallCollapsed.propTypes = {
  toolCall: PropTypes.object.isRequired,
  toolResult: PropTypes.any,
  onClick: PropTypes.func.isRequired
}

export default ToolCallCollapsed
